import File from './file';

export default {
  File,
};
